// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "circle[data-v-08a3dc78]{transform:rotate(-90deg);transform-origin:50% 50%}", "",{"version":3,"sources":["webpack://./resources/assets/js/components/all/ProgressRing.vue"],"names":[],"mappings":"AACA,wBACE,wBAAA,CACA,wBAAF","sourcesContent":["\ncircle {\n  transform: rotate(-90deg);\n  transform-origin: 50% 50%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
